// extracted by mini-css-extract-plugin
export var searchHeader = "_l-0";
export var searchHeaderDark = "_l-1";